module.exports = __webpack_public_path__ + "img/sunflower.036c3114.png";